/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import CheckIn from './CheckIn/index'
import Checkout from './Checkout/index'
import No from './No/index'
import React from 'react'
import Reschedule from './Reschedule/index'
import Schedule from './Schedule/index'
import Seat from './Seat/index'
import Unseat from './Unseat/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/PatientOverlay/Content/Content/Appointments/TabContent/Content/AppointmentsList/Content/Appointment/BottomAction/Content"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let eventValueData = fromData.useDataFormat({ viewPath,
context: 'event',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: eventValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Schedule'}>
<Schedule
  viewPath={`${viewPath}/Schedule`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Reschedule'}>
<Reschedule
  viewPath={`${viewPath}/Reschedule`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'CheckIn'}>
<CheckIn
  viewPath={`${viewPath}/CheckIn`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Checkout'}>
<Checkout
  viewPath={`${viewPath}/Checkout`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Seat'}>
<Seat
  viewPath={`${viewPath}/Seat`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Unseat'}>
<Unseat
  viewPath={`${viewPath}/Unseat`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}